// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4538":"cf65b028","5590":"ead23ee3","6822":"7dad95c8"}[chunkId] + ".chunk.css";
};